import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { ProfileService } from "../services/profile.service";
import { UpdateProfileDto } from "../dto/profile.dto";

export const useGetMyProfileHook = () => {
  return useQuery({
    queryKey: ["profile", "me"],
    queryFn: () => ProfileService.getMe(),
  });
};

export const useUpdateMyProfileHook = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: UpdateProfileDto) => ProfileService.updateMe(data),
    onSuccess: () =>
      queryClient.invalidateQueries({ queryKey: ["profile", "me"] }),
  });
};
